<script setup>
import { IonIcon } from "@ionic/vue";
import { add } from "ionicons/icons";

defineProps({
	basket: Object,
	personalisation: Boolean,
	commentsOnly: Boolean,
	addingToBasket: Boolean,
	taxStatus: {
		type: Boolean,
		default: false,
	},
	nonTaxable: {
		type: Boolean,
		default: false,
	},
});

const emits = defineEmits(["@add-to-basket", "@add-personalisation-section"]);
</script>

<template>
	<div>
		<template v-if="personalisation && !commentsOnly">
			<span
				class="e-btn e-btn--priamary e-btn--full u-flex u-v-center u-h-center u-gap-quarter"
				@click="emits('@add-personalisation-section')"
			>
				<IonIcon :icon="add" /> Add another logo</span
			>
		</template>

		<p
			class="e-heading e-heading--three e-heading--two@ipad-pro e-heading--secondary u-my u-my-alt@ipad-pro"
		>
			Total
			<span class="e-heading--two e-heading--one@ipad-pro"
				>&pound;{{ parseFloat(basket.total).toFixed(2) }}</span
			>
			<span v-if="!nonTaxable">
				{{ taxStatus && !nonTaxable ? "Inc" : "Ex" }} VAT
			</span>
		</p>

		<button
			@click="emits('@add-to-basket')"
			class="e-btn e-btn--full e-btn--buy"
			v-if="
				basket.products && basket.products.length && parseInt(basket.total) > 0
			"
			:disabled="addingToBasket"
		>
			Add to Basket
		</button>
	</div>
</template>
